/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StatusCode } from '../../api/enumerations';
import manualCalcultionAPI from '../../api/manualCalculation';
import { CompletionData as ManualCompletionData } from '../../api/manualCalculation/types';
import { PreviousStatus } from '../../api/workOrders';
import { AllAttachments } from '../../components/AllAttachments';
import ConfirmationDeleteDialog from '../../components/ConfirmationDeleteDialog';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import { MessagesDialog } from '../../components/Messages';
import { PeptDialog } from '../../components/PeptDialog';
import { AccordionTitle } from '../../components/Sections/AccordionTitle';
import { AssociatedWorkOrders } from '../../components/Sections/AssociatedWorkOrders';
import { ClientData } from '../../components/Sections/ClientData';
import { FormResponse } from '../../components/Sections/FormResponse';
import { HiveDeadlineBar } from '../../components/Sections/HiveDeadlineBar';
import { WorkOrderProgressBar } from '../../components/Sections/ProgressBar';
import { PropertyAddressWithMaps } from '../../components/Sections/PropertyAddressWithMaps';
import { PropertyData } from '../../components/Sections/PropertyData';
import { PropertyInfo } from '../../components/Sections/PropertyInfo';
import { ReportInfo } from '../../components/Sections/ReportInfo';
import { Rooms } from '../../components/Sections/Rooms';
import { SampleSection } from '../../components/Sections/Sample';
import { ScheduleInfo } from '../../components/Sections/ScheduleInfo';
import { Title } from '../../components/Sections/Title';
import { ToogleAccordion } from '../../components/Sections/ToogleAccordion';
import Snackbar from '../../components/Snackbar';
import {
  BoxContainer,
  CancelOsBox,
  FlexSpaceBetweenBox,
  LoadingBox,
  SectionBox,
} from '../../components/UI/Box';
import { BackButton } from '../../components/UI/Button';
import { GridContainer } from '../../components/UI/Grid';
import {
  ColoredCircularProgress,
  WhiteCircularProgress,
} from '../../components/UI/Typography';
import {
  IconApartmentMS,
  IconArrowCircleLeftMS,
  IconAssignmentMS,
  IconCalendarTodayMS,
  IconEditDocumentMS,
  IconEngineeringMS,
  IconFactCheckMS,
  IconListAltMS,
  IconLocationCityMS,
  IconLocationOnMS,
  IconPhotoLibraryMS,
} from '../../constants/icons';
import { Constants } from '../../constants/report';
import { GlobalContext } from '../../context/global';
import { useAccordion } from '../../hooks/useAccordion';
import { useCancelWorkOrder } from '../../hooks/useCancelWorkOrder';
import { useChangeStatus } from '../../hooks/useChangeStatus';
import useErrorMessage from '../../hooks/useErrorMessage';
import useGeneral from '../../hooks/useGeneral';
import { CharacteristicsSectionSummary } from '../Characteristics/components/SectionSummary';
import { EditableComplementaryFieldsSection } from './components/ComplementaryFieldsSection/Editable';
import { ReadonlyComplementaryFieldsSection } from './components/ComplementaryFieldsSection/Readonly';
import { InspectionSelectedPhotos } from './components/InspectionSelectedPhotos';
import useReport from './hooks';
import { ScientificTreatmentSummary } from './ScientificTreatment/components/SectionSummary';
import {
  AvmStatusBox,
  BackToSamplesButton,
  ContainerHeaderButtons,
  SubmitBox,
} from './styles';

export function Report(): JSX.Element {
  const {
    openSnackbar,
    setOpenSnackbar,
    setErrorMessage,
    setSnackbarMessage,
    isHiveOwner,
  } = useContext(GlobalContext);

  const {
    propertyData,
    selectedPictures,
    removeSelectedPictures,
    getCharts,
    handleChangeStatus,
    loadingPage,
    avmStatus,
    forceFactors,
    forceTransformations,
    hasAvmReport,
    sampleData,
    rooms,
    completedSections,
    updateAdditionalFields,
    openAttchamentsDialog,
    onCloseAttachments,
    completionData,
    loadingCompletion,
    isLegacyCharacteristicsData,
  } = useReport();

  const hasAVM = propertyData?.avm_status !== null;

  const {
    expandOne,
    setExpandOne,
    expandTwo,
    setExpandTwo,
    expandThree,
    setExpandThree,
    expandFour,
    setExpandFour,
    expandFive,
    setExpandFive,
    expandSix,
    setExpandSix,
    expandSeven,
    setExpandSeven,
    expandEight,
    setExpandEight,
    expandNine,
    setExpandNine,
    expandTen,
    setExpandTen,
    expandEleven,
    setExpandEleven,
    expandAll,
    setExpandAll,
    toggleAccordions,
  } = useAccordion();
  const { handleCancelWorkOrder } = useCancelWorkOrder();
  const { loadingApprove, loadingPreviousStatus } = useChangeStatus();
  const { getErrorMessage } = useErrorMessage();
  const { osId, navigateHome } = useGeneral();
  const navigate = useNavigate();

  const [manualCompletion, setManualCompletion] = useState<
    ManualCompletionData | undefined
  >();
  const [loadingManual, setLoadingManual] = useState(false);

  const getScientificTreatmentCompletion =
    useCallback(async (): Promise<void> => {
      try {
        setLoadingManual(true);
        const response = await manualCalcultionAPI.getCompletion(osId);
        if (response.detail.description)
          throw new Error(response.detail.description);
        if (response.data) setManualCompletion(response.data);
      } catch {
        // silently fail — summary will show error state
      } finally {
        setLoadingManual(false);
      }
    }, [osId]);

  useEffect(() => {
    if (
      expandOne &&
      expandTwo &&
      expandThree &&
      expandFour &&
      expandFive &&
      expandSix &&
      expandSeven &&
      expandEight &&
      expandNine &&
      expandTen &&
      expandEleven
    ) {
      setExpandAll(true);
    } else {
      setExpandAll(false);
    }
  }, [
    expandOne,
    expandTwo,
    expandThree,
    expandFour,
    expandFive,
    expandSix,
    expandSeven,
    expandEight,
    expandNine,
    expandTen,
    expandEleven,
  ]);

  useEffect(() => {
    setExpandEight(true);
    if (propertyData) getScientificTreatmentCompletion();
  }, [propertyData]);

  const redirectToPreviousStatus = useCallback(async () => {
    try {
      const response = await PreviousStatus(osId);

      if (response.detail.description) {
        throw new Error(response.detail.description);
      }

      if (response.detail.status_code !== StatusCode.OK) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setOpenSnackbar(true);
      setErrorMessage(true);
    }
  }, []);

  return (
    <GridContainer>
      <BackButton onClick={navigateHome}>{IconArrowCircleLeftMS}</BackButton>
      <BoxContainer>
        <Title
          osNumber={propertyData?.reference_number || 0}
          title={Constants.reportPreparation}
          createdAt={propertyData?.created_at}
        />
        {loadingPage ? (
          <LoadingBox>
            <ColoredCircularProgress />
          </LoadingBox>
        ) : (
          <>
            {isHiveOwner && propertyData && propertyData.hive_request && (
              <HiveDeadlineBar
                slaStatus={propertyData.sla_status}
                slaDaysElapsed={propertyData.sla_days_elapsed}
                slaDaysRemaining={propertyData.sla_days_remaining}
                requestCreatedAt={propertyData.hive_request.created_at}
                requestLimitDate={propertyData.hive_request.complete_until}
              />
            )}
            <FlexSpaceBetweenBox>
              <CancelOsBox>
                <ConfirmationDeleteDialog
                  iconCancel
                  title={Constants.cancelOs}
                  text={Constants.cancelOsText}
                  modalCallback={handleCancelWorkOrder}
                />
              </CancelOsBox>
              <Box display="flex" gap={1.2}>
                {isHiveOwner &&
                  propertyData &&
                  propertyData?.worker_company_id !== null && (
                    <MessagesDialog
                      osId={osId}
                      hiveRequest={propertyData?.hive_request || undefined}
                    />
                  )}
                <AllAttachments
                  propertyData={propertyData}
                  osId={osId}
                  open={openAttchamentsDialog}
                  onClose={onCloseAttachments}
                />
              </Box>
            </FlexSpaceBetweenBox>
            {avmStatus.length > 0 && (
              <AvmStatusBox>
                {avmStatus}
                {Constants.avmFailedHint}
              </AvmStatusBox>
            )}
            <WorkOrderProgressBar complete>
              <>
                <ClientData propertyData={propertyData} />
                <ToogleAccordion expand={expandAll} toogle={toggleAccordions} />
              </>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyData}
                  icon={IconApartmentMS}
                  openAccordion={expandOne}
                  setOpenAccordion={setExpandOne}
                />
                {expandOne && <PropertyData propertyData={propertyData} />}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyAddress}
                  icon={IconLocationOnMS}
                  openAccordion={expandTwo}
                  setOpenAccordion={setExpandTwo}
                />
                {expandTwo && (
                  <PropertyAddressWithMaps
                    checkLocation
                    propertyData={propertyData}
                  />
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyDetails}
                  icon={IconLocationCityMS}
                  openAccordion={expandThree}
                  setOpenAccordion={setExpandThree}
                />
                {expandThree && <PropertyInfo propertyData={propertyData} />}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.scheduleInfo}
                  icon={IconCalendarTodayMS}
                  openAccordion={expandFour}
                  setOpenAccordion={setExpandFour}
                />
                {expandFour && (
                  <Box>
                    {propertyData?.inspection?.engineer_id ? (
                      <ScheduleInfo
                        inspectionData={propertyData.inspection}
                        rooms={rooms}
                        workerCompanyId={
                          propertyData.worker_company_id || undefined
                        }
                      />
                    ) : (
                      <Typography>{Constants.noInspection}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete={completedSections.propertyImages}>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyPhotos}
                  icon={IconPhotoLibraryMS}
                  openAccordion={expandFive}
                  setOpenAccordion={setExpandFive}
                />
                {expandFive && (
                  <Box>
                    {propertyData?.inspection && rooms.length > 0 ? (
                      <Rooms
                        navigationPath={`${osId}/inspection/${propertyData.inspection.id}/rooms`}
                        rooms={rooms}
                        osId={osId}
                        inspectionId={propertyData.inspection.id}
                      />
                    ) : (
                      <Typography>{Constants.noPhotos}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.form}
                  icon={IconListAltMS}
                  openAccordion={expandSix}
                  setOpenAccordion={setExpandSix}
                />
                {expandSix && (
                  <Box>
                    {propertyData?.inspection?.form_response ? (
                      <FormResponse
                        questionForm={propertyData.inspection.form_response}
                      />
                    ) : (
                      <Typography>{Constants.noForm}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.sample}
                  icon={IconFactCheckMS}
                  openAccordion={expandSeven}
                  setOpenAccordion={setExpandSeven}
                />
                {expandSeven && (
                  <Box>
                    {sampleData && sampleData?.length > 0 ? (
                      <SampleSection
                        sampleData={sampleData}
                        propertyData={propertyData}
                      />
                    ) : (
                      <Typography>{Constants.noSample}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar
              complete={hasAVM ? true : manualCompletion?.is_complete ?? false}
            >
              <SectionBox>
                <AccordionTitle
                  title={
                    hasAVM ? Constants.report : Constants.scientificTreatment
                  }
                  icon={IconEngineeringMS}
                  openAccordion={expandEight}
                  setOpenAccordion={setExpandEight}
                />
                {expandEight && (
                  <Box>
                    {hasAVM ? (
                      hasAvmReport && propertyData ? (
                        <ReportInfo
                          propertyData={propertyData}
                          getCharts={getCharts}
                          forceFactors={forceFactors}
                          forceTransformations={forceTransformations}
                        />
                      ) : (
                        <Box>{Constants.reportError}</Box>
                      )
                    ) : (
                      <ScientificTreatmentSummary
                        loading={loadingManual}
                        completionData={manualCompletion}
                      />
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            {propertyData?.property_characteristics_form && (
              <WorkOrderProgressBar complete>
                <SectionBox>
                  <AccordionTitle
                    title={Constants.characteristics}
                    icon={IconAssignmentMS}
                    openAccordion={expandNine}
                    setOpenAccordion={setExpandNine}
                  />
                  {expandNine && (
                    <CharacteristicsSectionSummary
                      completionData={completionData}
                      loadingCompletion={loadingCompletion}
                      isLegacyCharacteristicsData={isLegacyCharacteristicsData}
                    />
                  )}
                </SectionBox>
              </WorkOrderProgressBar>
            )}
            <WorkOrderProgressBar complete={completedSections.additionalFields}>
              <SectionBox>
                <AccordionTitle
                  title="Campos complementares"
                  icon={IconEditDocumentMS}
                  openAccordion={expandTen}
                  setOpenAccordion={setExpandTen}
                />
                {expandTen && (
                  <Box>
                    {!isHiveOwner && propertyData?.avm_report ? (
                      <EditableComplementaryFieldsSection
                        avmData={propertyData.avm_report}
                        osId={osId}
                        updateAdditionalFields={updateAdditionalFields}
                      />
                    ) : propertyData?.avm_report?.descriptions ? (
                      <ReadonlyComplementaryFieldsSection
                        descriptionData={propertyData?.avm_report?.descriptions}
                      />
                    ) : (
                      <Typography>
                        {Constants.complementaryFieldsError}
                      </Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar
              complete={completedSections.inspectionImages}
              lastAccordion
            >
              <SectionBox>
                <AccordionTitle
                  title="Imagens vistoria"
                  icon={IconPhotoLibraryMS}
                  openAccordion={expandEleven}
                  setOpenAccordion={setExpandEleven}
                />
                {expandEleven && (
                  <Box>
                    {propertyData?.inspection?.id && rooms.length > 0 ? (
                      <InspectionSelectedPhotos
                        selectedPhotos={selectedPictures}
                        inspectionId={propertyData?.inspection?.id}
                        removeSelection={removeSelectedPictures}
                      />
                    ) : (
                      <Typography>{Constants.noPhotos}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <AssociatedWorkOrders osId={osId} />
            {!isHiveOwner && (
              <SubmitBox>
                <ContainerHeaderButtons>
                  <BackToSamplesButton
                    disabled={loadingPreviousStatus}
                    onClick={redirectToPreviousStatus}
                  >
                    {loadingPreviousStatus ? (
                      <WhiteCircularProgress size={22} />
                    ) : (
                      Constants.backToSample
                    )}
                  </BackToSamplesButton>
                  <PeptDialog
                    osId={osId}
                    referenceNumber={propertyData?.reference_number}
                  />
                </ContainerHeaderButtons>
                <ConfirmationDialog
                  title={Constants.approve}
                  loading={loadingApprove}
                  text={Constants.changeStatus.replace(
                    '**',
                    `${propertyData?.reference_number}`
                  )}
                  modalCallback={handleChangeStatus}
                />
              </SubmitBox>
            )}
          </>
        )}
      </BoxContainer>
      {openSnackbar && <Snackbar />}
    </GridContainer>
  );
}
